import { select, call, put, fork } from "redux-saga/effects";

import * as actionTypes from "constants/actionTypes";
import { selectAccountId } from "reducers/account/meta";
import { selectAccountChecklist } from "reducers/account/checklists";
import * as firebase from "sagas/firebase/lib";
import { throttleBy } from "utils/sagas";

export function* replaceAccountChecklists(res) {
  const { data } = res;
  yield put({
    type: actionTypes.REPLACE_ACCOUNT_CHECKLISTS,
    payload: data || {}
  });
}

export function* replaceAccountChecklist(res) {
  const { key, data } = res;

  yield put({
    type: actionTypes.REPLACE_ACCOUNT_CHECKLIST,
    payload: {
      checklistId: key,
      checklist: data
    }
  });
}

function* flushChecklistToFirebase(action) {
  const { checklistId } = action.payload;

  const accountId = yield select(selectAccountId);
  const checklist = yield select(selectAccountChecklist, checklistId);

  if (checklist) {
    yield call(
      firebase.set,
      `accounts/${accountId}/checklists/${checklistId}`,
      checklist
    );
  } else {
    yield call(firebase.remove, [
      `accounts/${accountId}/checklists/${checklistId}`
    ]);
  }
}

export default function* checklists() {
  yield fork(
    throttleBy,
    "checklistId",
    500,
    actionTypes.FLUSH_CHECKLIST_TO_FIREBASE,
    flushChecklistToFirebase
  );
}
